module.exports = __webpack_public_path__ + "img/icon3.3a7a9b09.gif";